import React from "react"

import { ProfileDeleteSubmitCodeOverlay } from "./ProfileDeleteCodeOverlay"
import { useProfileDeleteSubmitCodeOverlayModel } from "./model/useProfileDeleteCodeOverlayModel"

export const ProfileDeleteSubmitCodeOverlayConnector = React.memo(() => {
  return (
    <ProfileDeleteSubmitCodeOverlay
      {...useProfileDeleteSubmitCodeOverlayModel()}
    />
  )
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROFILE_DELETE_CODE_OVERLAY: null
  }
}
